/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'filter': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<path pid="0" d="M1.5 1a.5.5 0 00-.407.791l3.68 5.145c.183.255.281.56.281.873v3.186a.5.5 0 00.203.402l2.072 1.526a.5.5 0 00.796-.402V7.702c0-.212.046-.42.132-.614l2.417-5.383A.5.5 0 0010.217 1H1.5h0z" _stroke="#FFF" _fill="none" fill-rule="evenodd"/>'
  }
})
